import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Project from "./project"

const Webprojects = () => {
    const data = useStaticQuery(
        graphql`
        {
            web_projects: allMarkdownRemark(filter: {internal: {}, fields: {collection: {eq: "web_projects"}}}, sort: {fields: frontmatter___date, order: ASC}) {
              group(field: frontmatter___year) {
                edges {
                  node {
                    id
                    frontmatter {
                      client
                      role
                      title
                      year
                      month
                      linkout
                      technologies
                      released
                      date(formatString: "YYYY")
                      featuredImage {
                        childImageSharp {
                          fluid {
                            ...GatsbyImageSharpFluid
                          }
                        }
                      }
                    }
                    rawMarkdownBody
                  }
                }
                fieldValue
              }
            }
          }
        `
      )
    let totalIndex = 0  
    return (    
        <div>
            <h1 className="text-3xl md:text-5xl px-10 md:px-40">Selected Web Projects</h1>
            {
                data.web_projects.group.reverse().map((item, index) => {
                    return (
                      <ul className="projects">
                          <li className="divider px-10 md:px-40 py-8 w-auto" key={item.fieldValue +"-divider"}>
                            <h2 className="text-sml md:text-2xl w-auto inline-block">
                              { item.fieldValue }
                            </h2>
                            <div className="bar mx-20 md:mx-40"></div>
                          </li>
                          {
                            item.edges.reverse().map((item, index) => {
                              if(item.node.frontmatter.released !== false) {
                                totalIndex++
                                return (
                                  <Project content={item.node} itemIndex={totalIndex} />
                                );
                              } else {
                                return (
                                  false
                                )
                              }
                            })
                          }        
                      </ul>
                    );
                })
            }
        </div>
    )
}
  
export default Webprojects   